import React from 'react';
import useBoolean from 'src/shared/hooks/useBoolean';
import UploadDataModal from 'src/shared/components/upload-data-modal/UploadDataModal';
import { PrimaryButton } from 'src/shared/components/button/Button';
import BookCallModal from 'src/app/portfolio/components/book-call-modal/BookCallModal';
import { DetectionBadgeType } from '../detection-badge/DetectionBadge';

type TableUpsellSectionProps = {
    type: DetectionBadgeType.BookCall | DetectionBadgeType.UploadData;
};

export const TableUpsellSection = ({ type }: TableUpsellSectionProps) => {
    const [showImportModal, setShowImportModal] = useBoolean(false);
    const [showBookCallModal, setShowBookCallModal] = useBoolean(false);

    const onClick = () => {
        if (type === DetectionBadgeType.BookCall) {
            setShowBookCallModal.on();
        } else if (type === DetectionBadgeType.UploadData) {
            setShowImportModal.on();
        }
    };

    const title = type === DetectionBadgeType.BookCall ? 'No sample data' : 'No data available';
    const description =
        type === DetectionBadgeType.BookCall
            ? 'Increase your data quality with ground-truthed eDNA & bioacoustics species insights.'
            : 'Upload your own biodiversity data.';

    return (
        <>
            <div className='flex flex-col gap-3 bg-grey-0 border border-grey-20 p-4 rounded-md h-full justify-center'>
                <div className='flex flex-col gap-0'>
                    <div className='text-sm font-medium text-center'>{title}</div>
                    <div className='text-xs text-center'>{description}</div>
                </div>
                <PrimaryButton onClick={onClick} className='w-[fit-content] self-center'>
                    Learn more
                </PrimaryButton>
            </div>
            {showImportModal && <UploadDataModal onClose={setShowImportModal.off} />}
            {showBookCallModal && <BookCallModal onClose={setShowBookCallModal.off} />}
        </>
    );
};

export default TableUpsellSection;
